import empRaisesAndDeductionsReducer from "./reducers";
export { default as empRaisesAndDeductionsTypes } from "./types";
export { default as empRaisesAndDeductionsOperations } from "./operations";
export default empRaisesAndDeductionsReducer;
